import Env from 'lib/Env';
import { MAINTENANCE } from 'lib/messages';
import { aquaAxiosWithCreds, callAsyncWithRetry } from '../../lib/utilityFunctions';
import { showStandardErrorPage, getErrorActionObject } from '../components/GlobalErrorHandler/actions';

import GAME_IDS from '../hub/data/GameIds';
import { FEATURE_TOGGLE_TYPES } from '../reducers/featureToggleReducer';

const toggleValidationFns = {
  clientA11yFeatures: val => !!+val,
  allowPrototypePlaytesting: val => !!+val,
  showRealTimeUsage: val => !!+val,
};

const validateToggles = toggles => Object.entries(toggleValidationFns).reduce((validToggles, [key, validationFn]) => ({
  ...validToggles,
  ...(toggles[key] ? { [key]: validationFn(toggles[key]) } : {}),
}), {});

export const getFeatureToggles = () => async (dispatch) => {
  dispatch({ type: FEATURE_TOGGLE_TYPES.REQUEST_GET_FEATURE_TOGGLES });

  const asyncRetryFn = async () => {
    const { data } = await aquaAxiosWithCreds(`${Env.API_URL}/feature-toggle/v${Env.API_VERSION_KEYCLOAK}/setting`);
    if (data.app_fixed_version === MAINTENANCE) {
      window.location.href = `${window.location.origin}/error.html?message=${MAINTENANCE}`;
      return {};
    }
    const validatedToggles = validateToggles(data);
    dispatch({
      type: FEATURE_TOGGLE_TYPES.RESPONSE_GET_FEATURE_TOGGLES,
      payload: validatedToggles,
    });
    return validatedToggles;
  };

  const asyncRetryConfig = {
    logger: async ({ name, message }, { isDoneRetrying }) => {
      dispatch(getErrorActionObject(
        GAME_IDS.METAGAME_ID,
        message,
        'API: featureToggle',
        'API: getFeatureToggles',
        'api',
      ));
      if (isDoneRetrying) {
        // This API is part of loading percentage screen.
        // Clear loading UX to show Error screen
        window.reactLoaded();
        // Show Uh Oh error screen
        dispatch(showStandardErrorPage(name, message));
      }
    },
  };

  return callAsyncWithRetry(asyncRetryFn, asyncRetryConfig);
};

/**
 * This action is fired when a seasonal feature bonus theme or animation is complete,
 * so Reducer can increment a count of how often the user has seen this bonus feature
 */
export const seasonalAnimationComplete = seasonalKey => ({
  type: FEATURE_TOGGLE_TYPES.SEASONAL_ANIMATION_COMPLETE,
  payload: {
    seasonalKey,
  },
});

/**
 * This action toggles a seasonal feature (eg, "Halloween theme for Bookerton map")
 * between on and off
 */
export const toggleSeasonalFeature = seasonalKey => ({
  type: FEATURE_TOGGLE_TYPES.TOGGLE_SEASONAL_FEATURE,
  payload: {
    seasonalKey,
  },
});
